import { carBatteryLanding, servicePage } from '@/constants/routes';

export const CAMPAIGN_COUPON_CODE = 'B2B400';
export const CAMPAIGN_DISCOUNT_AMOUNT = 400000;

export const CAMPAIGN_PRODUCTS_SECTION_ID = 'campaign-products';
export const CAMPAIGN_REWARD_SECTION_ID = 'campaign-reward';

export const CAMPAIGN_PRODUCTS_SIZE = 8;
export const CAMPAIGN_SPARE_PARTS_PRODUCTS_SIZE = 8;

export const allBatteriesHref = carBatteryLanding;
export const allSparePartsHref = servicePage;
